<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='100px' :inline='true'>
        <el-form-item label='考核模块：'>
          <el-input v-model='searchForm.moduleName' size='mini' placeholder='请输入考核模块' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'> 查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <!--<el-button size='small' class='searchBtn' @click='enableOrDisable'>启用/停用</el-button>-->
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='downloadTarget'>考核指标</span>
          <batch-import :uploadUrl='batchImportTarget' @importSuccess='searchBtn'
                        :uploadText='"考核指标批量导入"' />
          <span @click='downloadCriteria'>评分标准模板下载</span>
          <batch-import :uploadUrl='batchImportCriteria' @importSuccess='searchBtn'
                        :uploadText='"评分标准批量导入"' />
        </div>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @selection-change='selectionChange'
        :row-style="rowStyle"
      >
        <el-table-column type='selection' align='center' min-width='50' />
        <el-table-column type='index' align='center' min-width='50' />
        <el-table-column label='考核模块' prop='moduleName' align='center' />
        <el-table-column label='考核指标数量' prop='kpiNumber' align='center' />
        <el-table-column label='操作' width='205' align='center'>
          <template slot-scope='scope'>
            <el-button size='mini' class='searchBtn' type='primary'
                       @click='indicatorManagement(scope.row)'>指标管理
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 指标管理 -->
    <indicator-management ref='indicatorManagementRef' @getTableData='getTableData' />
  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';
  import IndicatorManagement from './components/indicatorManagement';
  import { indicatorSettingsList } from '@/service/supplierAssessment';

  export default {
    name: 'monthlyAssessmentIndexSetting',
    components: {
      BatchImport,
      IndicatorManagement,
    },
    data() {
      return {
        searchForm: {
          moduleName: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        selectedData: [],
        tipOne: true,
        settlement: '',
        batchImportTarget: '/supplierMonthExamineManage/batchImportTarget',
        batchImportCriteria: '/supplierMonthExamineManage/batchImportCriteria',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      enableOrDisable() {
        if (this.selectedData.length === 0) return this.$message.warning('请选择数据后生成对账单');
        this.clearSelectedData();
      },
      // 指标管理
      indicatorManagement(row) {
        this.$refs.indicatorManagementRef.dialogOpen(row);
      },
      downloadTarget() {
        window.location.href = '/file/考核模块模板.xlsx';
      },
      downloadCriteria() {
        window.location.href = '/file/考核评分标准模板.xlsx';
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await indicatorSettingsList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionChange(selectionRow) {
        this.selectedData = selectionRow;
      },
      clearSelectedData() {
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          moduleName,
          name,
          settlementType,
          standingBookMonth,
          brand,
          isReconciliation,
        } = this.searchForm;
        // window.location.href = `${baseUrl}/platform/settlement/supplierPortAndWarehouse/exportExcel?access_token=${token}&moduleName=${moduleName || ''}&name=${name || ''}&settlementType=${settlementType || ''}&standingBookMonth=${standingBookMonth || ''}&brand=${brand || ''}&isReconciliation=${isReconciliation || ''}`;
        window.exportExcelGet('/platform/settlement/supplierPortAndWarehouse/exportExcel', `moduleName=${moduleName || ''}&name=${name || ''}&settlementType=${settlementType || ''}&standingBookMonth=${standingBookMonth || ''}&brand=${brand || ''}&isReconciliation=${isReconciliation || ''}`)
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
